import { useEffect, useState } from "react";

export const GifsNotFound = () => {
  const [canShow, setCanShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCanShow(true);
    }, 250);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!canShow) return null;

  return (
    <div className="tw-mt-6 tw-flex tw-flex-col tw-items-center tw-text-center">
      <img
        alt="No results found"
        src="/assets/images/no-results-found.svg"
        className="tw-mb-2 tw-size-[87px]"
      />
      <div className="tw-mb-2 tw-text-lg tw-font-bold">No results found</div>
      <div className="tw-text-[13px]">
        Try a different keyword to refine your search
      </div>
    </div>
  );
};
